import React, { useCallback, useEffect } from 'react'

import ReactDOM from 'react-dom'

import getScrollbarSize from 'helpers/getScrollbarSize'
import { useTransition } from 'hooks'

import DrawerWrapper from './components/DrawerWrapper'

const Drawer = ({
  children,
  isSeoFriendly,
  open,
  onClose,
  modalProps,
  anchor = 'left',
  paperProps = {},
  className,
  ...props
}) => {
  const { shouldMount, stage } = useTransition(open, 300)

  // Memoize the escape key handler to avoid re-creating it on every render
  const handleKeyDown = useCallback(
    event => {
      if (open && event?.key === 'Escape' && onClose) {
        onClose(event)
      }
    },
    [open, onClose]
  )

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])

  useEffect(() => {
    if (open) {
      document.body.style.paddingRight = modalProps?.disableScrollLock ? '0px' : `${getScrollbarSize()}px`
      document.body.style.overflow = modalProps?.disableScrollLock ? 'initial' : 'hidden'
    } else {
      const timeoutId = setTimeout(() => {
        document.body.style.paddingRight = '0px'
        document.body.style.overflow = 'initial'
      }, 250)
      return () => clearTimeout(timeoutId)
    }
  }, [modalProps?.disableScrollLock, open])

  const drawerContent = (
    <DrawerWrapper
      shouldMount={shouldMount}
      stage={stage}
      anchor={anchor}
      className={className}
      modalProps={modalProps}
      paperProps={paperProps}
      onClose={onClose}
      {...props}
    >
      {children}
    </DrawerWrapper>
  )

  return isSeoFriendly
    ? drawerContent
    : shouldMount
    ? ReactDOM.createPortal(drawerContent, document?.getElementById('portal_root') || document.body)
    : null
}

export default Drawer
